import { useEffect, useRef, useState } from 'react';

/**
 * Returns [ref, isVisible].
 * Attach `ref` to the element you want to reveal.
 * Apply the `reveal` CSS class immediately and `is-visible` when it enters the viewport.
 * Uses a fixed IntersectionObserver (threshold 0.12, bottom root margin).
 */
export const useScrollReveal = () => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return [ref, isVisible];
};
